// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/watcher.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_common } from "./common_pb.js";
import { file_vitesse_v1_entitlements } from "./entitlements_pb.js";
import { file_vitesse_v1_ids } from "./ids_pb.js";
import { file_vitesse_v1_network } from "./network_pb.js";
/**
 * Describes the file vitesse/v1/watcher.proto.
 */
export const file_vitesse_v1_watcher = /*@__PURE__*/ fileDesc("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", [file_vitesse_v1_common, file_vitesse_v1_entitlements, file_vitesse_v1_ids, file_vitesse_v1_network]);
/**
 * Describes the message vitesse.v1.WatchValue.
 * Use `create(WatchValueSchema)` to create a new message.
 */
export const WatchValueSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 0);
/**
 * Describes the message vitesse.v1.WatchedSymbol.
 * Use `create(WatchedSymbolSchema)` to create a new message.
 */
export const WatchedSymbolSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 1);
/**
 * Describes the message vitesse.v1.WatchedVariable.
 * Use `create(WatchedVariableSchema)` to create a new message.
 */
export const WatchedVariableSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 2);
/**
 * Describes the message vitesse.v1.ValueCondition.
 * Use `create(ValueConditionSchema)` to create a new message.
 */
export const ValueConditionSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 3);
/**
 * Describes the message vitesse.v1.ModelStateCondition.
 * Use `create(ModelStateConditionSchema)` to create a new message.
 */
export const ModelStateConditionSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 4);
/**
 * Describes the message vitesse.v1.IdsAlertCondition.
 * Use `create(IdsAlertConditionSchema)` to create a new message.
 */
export const IdsAlertConditionSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 5);
/**
 * Describes the message vitesse.v1.LinkCondition.
 * Use `create(LinkConditionSchema)` to create a new message.
 */
export const LinkConditionSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 6);
/**
 * Describes the message vitesse.v1.WatchCondition.
 * Use `create(WatchConditionSchema)` to create a new message.
 */
export const WatchConditionSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 7);
/**
 * Describes the message vitesse.v1.AiRunTarget.
 * Use `create(AiRunTargetSchema)` to create a new message.
 */
export const AiRunTargetSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 8);
/**
 * Describes the message vitesse.v1.WatchTarget.
 * Use `create(WatchTargetSchema)` to create a new message.
 */
export const WatchTargetSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 9);
/**
 * Describes the message vitesse.v1.Watch.
 * Use `create(WatchSchema)` to create a new message.
 */
export const WatchSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 10);
/**
 * Describes the message vitesse.v1.WatchState.
 * Use `create(WatchStateSchema)` to create a new message.
 */
export const WatchStateSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 11);
/**
 * Describes the message vitesse.v1.ArmWatchRequest.
 * Use `create(ArmWatchRequestSchema)` to create a new message.
 */
export const ArmWatchRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 12);
/**
 * Describes the message vitesse.v1.ArmWatchReply.
 * Use `create(ArmWatchReplySchema)` to create a new message.
 */
export const ArmWatchReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 13);
/**
 * Describes the message vitesse.v1.CancelWatchRequest.
 * Use `create(CancelWatchRequestSchema)` to create a new message.
 */
export const CancelWatchRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 14);
/**
 * Describes the message vitesse.v1.CancelWatchReply.
 * Use `create(CancelWatchReplySchema)` to create a new message.
 */
export const CancelWatchReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 15);
/**
 * Describes the message vitesse.v1.DeliverWatchReply.
 * Use `create(DeliverWatchReplySchema)` to create a new message.
 */
export const DeliverWatchReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 16);
/**
 * Describes the message vitesse.v1.AiArmWatchRequest.
 * Use `create(AiArmWatchRequestSchema)` to create a new message.
 */
export const AiArmWatchRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 17);
/**
 * Describes the message vitesse.v1.AiCancelWatchRequest.
 * Use `create(AiCancelWatchRequestSchema)` to create a new message.
 */
export const AiCancelWatchRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_watcher, 18);
/**
 * How a value is compared with its threshold.
 *
 * @generated from enum vitesse.v1.WatchComparison
 */
export var WatchComparison;
(function (WatchComparison) {
    /**
     * @generated from enum value: WATCH_COMPARISON_UNSPECIFIED = 0;
     */
    WatchComparison[WatchComparison["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: WATCH_COMPARISON_ABOVE = 1;
     */
    WatchComparison[WatchComparison["ABOVE"] = 1] = "ABOVE";
    /**
     * @generated from enum value: WATCH_COMPARISON_AT_OR_ABOVE = 2;
     */
    WatchComparison[WatchComparison["AT_OR_ABOVE"] = 2] = "AT_OR_ABOVE";
    /**
     * @generated from enum value: WATCH_COMPARISON_BELOW = 3;
     */
    WatchComparison[WatchComparison["BELOW"] = 3] = "BELOW";
    /**
     * @generated from enum value: WATCH_COMPARISON_AT_OR_BELOW = 4;
     */
    WatchComparison[WatchComparison["AT_OR_BELOW"] = 4] = "AT_OR_BELOW";
    /**
     * @generated from enum value: WATCH_COMPARISON_EQUALS = 5;
     */
    WatchComparison[WatchComparison["EQUALS"] = 5] = "EQUALS";
    /**
     * @generated from enum value: WATCH_COMPARISON_NOT_EQUALS = 6;
     */
    WatchComparison[WatchComparison["NOT_EQUALS"] = 6] = "NOT_EQUALS";
    /**
     * Any value different from the one current when the watch was armed. No threshold.
     *
     * @generated from enum value: WATCH_COMPARISON_CHANGES = 7;
     */
    WatchComparison[WatchComparison["CHANGES"] = 7] = "CHANGES";
})(WatchComparison || (WatchComparison = {}));
/**
 * Describes the enum vitesse.v1.WatchComparison.
 */
export const WatchComparisonSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_watcher, 0);
/**
 * @generated from enum vitesse.v1.WatchStatus
 */
export var WatchStatus;
(function (WatchStatus) {
    /**
     * @generated from enum value: WATCH_STATUS_UNSPECIFIED = 0;
     */
    WatchStatus[WatchStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: WATCH_STATUS_ARMED = 1;
     */
    WatchStatus[WatchStatus["ARMED"] = 1] = "ARMED";
    /**
     * @generated from enum value: WATCH_STATUS_FIRED = 2;
     */
    WatchStatus[WatchStatus["FIRED"] = 2] = "FIRED";
    /**
     * @generated from enum value: WATCH_STATUS_EXPIRED = 3;
     */
    WatchStatus[WatchStatus["EXPIRED"] = 3] = "EXPIRED";
    /**
     * @generated from enum value: WATCH_STATUS_CANCELLED = 4;
     */
    WatchStatus[WatchStatus["CANCELLED"] = 4] = "CANCELLED";
})(WatchStatus || (WatchStatus = {}));
/**
 * Describes the enum vitesse.v1.WatchStatus.
 */
export const WatchStatusSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_watcher, 1);
/**
 *
 * AiWatches — how an AI run with no browser arms and cancels a watch.
 *
 * Authenticated by a svcauth service token with the `watch:arm` scope, accepted HERE and nowhere
 * else. A separate scope and a separate service from AiFeed on purpose: AiFeed is structurally
 * read-only, and a leaked read token must not be able to arm anything, while a leaked arming token
 * can do exactly one thing — ask a gateway to watch its own data and wake a run of the same org.
 *
 * The org comes from the verified token, never the body; the gateway is named and CHECKED against the
 * org's owned set per request. The watch then rides `cmd.<gw>.watcher.*` to that gateway.
 *
 * @generated from service vitesse.v1.AiWatches
 */
export const AiWatches = /*@__PURE__*/ serviceDesc(file_vitesse_v1_watcher, 0);
//# sourceMappingURL=watcher_pb.js.map